import { c as e } from "../../../../index.esm-BeDSGXP5.js";
import { css as t } from "styled-components";
const l = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3csvg%20aria-label='Alert'%20width='24px'%20height='24px'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%2024%2024'%20enable-background='new%200%200%2024%2024'%20xml:space='preserve'%3e%3cg%3e%3cpath%20fill='%23CC2427'%20d='M22.54,18.87C21.49,17.05,14.3,4.4,13.5,3.03c-0.79-1.37-2.26-1.37-3.04,0C9.67,4.4,2.44,17.07,1.45,18.87%20C0.45,20.67,1.25,22,2.55,22c1.3,0,18.21,0,18.89,0C22.67,22,23.59,20.68,22.54,18.87z%20M13,18.99h-2v-2h2V18.99z%20M13,15.01h-2v-8h2%20V15.01z'%20/%3e%3c/g%3e%3c/svg%3e", n = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3csvg%20aria-label='Info'%20width='24px'%20height='24px'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%2024%2024'%20enable-background='new%200%200%2024%2024'%20xml:space='preserve'%3e%3cg%3e%3cpath%20fill='%23FA5600'%20d='M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10c5.52,0,10-4.48,10-10C22,6.48,17.52,2,12,2z%20M13,17.99h-2%20v-8h2V17.99z%20M13,8.01h-2v-2h2V8.01z'%20/%3e%3c/g%3e%3c/svg%3e", r = (o) => o.componentColors.forms.input, a = {
  assets: {
    alertIcon: l,
    infoIcon: n
  },
  base: ({ theme: o }) => /* @__PURE__ */ t([
    "",
    " display:block;border-radius:4px;border-width:2px;border-style:solid;box-sizing:border-box;height:4.8rem;max-width:100%;&:focus{outline:none !important;",
    "}&::placeholder{color:",
    ";}::-ms-input-placeholder{font-family:",
    ";color:",
    ";}",
    " background-position:right ",
    " center;background-repeat:no-repeat;"
  ], e({
    borderColor: r(o).border.default,
    fontSize: [
      "textMediumMobile",
      null,
      "textMediumDesktop"
    ],
    fontWeight: "regular",
    fontFamily: o.fonts.body,
    minWidth: [
      "100%",
      null,
      "26.8rem"
    ],
    paddingX: "sm",
    marginTop: "xs",
    lineHeight: [
      "textMediumMobile",
      null,
      "textMediumDesktop"
    ],
    color: r(o).text.default
  }), e({
    borderColor: r(o).border.focus
  }), r(o).text.placeholder, o.fonts.body, r(o).text.placeholder, o.components.forms.focusActiveState, o.space.sm),
  success: ({ theme: o }) => /* @__PURE__ */ t([
    "",
    " &:focus{",
    "}"
  ], e({
    borderColor: r(o).border.success
  }), e({
    borderColor: r(o).border.success
  })),
  error: ({ theme: o, showInformationalIcon: s = !0 }) => /* @__PURE__ */ t([
    "",
    " &:focus{",
    "}"
  ], e({
    borderColor: r(o).border.error,
    backgroundImage: s ? `url("${o.components.input.assets.alertIcon}")` : null,
    paddingRight: s ? "4.8rem" : null
  }), e({
    borderColor: r(o).border.error
  })),
  alert: ({ theme: o, showInformationalIcon: s = !0 }) => /* @__PURE__ */ t([
    "",
    " &:focus{",
    "}"
  ], e({
    borderColor: r(o).border.alert,
    backgroundImage: s ? `url("${o.components.input.assets.infoIcon}")` : null,
    paddingRight: s ? "4.8rem" : null
  }), e({
    borderColor: r(o).border.alert
  })),
  textArea: ({ theme: o }) => /* @__PURE__ */ t([
    "padding:",
    ";min-height:10rem;background-position:right ",
    " top ",
    ";resize:vertical;"
  ], o.space.sm, o.space.sm, o.space.sm)
};
export {
  a as default
};
